import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchAuditLogs = createAsyncThunk('audit/fetch', async (params = {}, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/audit/', { params });
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const fetchAuditResume = createAsyncThunk('audit/resume', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/audit/resume/');
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

const auditSlice = createSlice({
  name: 'audit',
  initialState: {
    logs:     [],
    count:    0,
    next:     null,
    previous: null,
    loading:  false,
    resume:   [],
    loadingResume: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Logs détaillés */
      .addCase(fetchAuditLogs.pending,  (s) => { s.loading = true; })
      .addCase(fetchAuditLogs.fulfilled,(s, a) => {
        s.loading = false;
        const d = a.payload;
        if (Array.isArray(d)) {
          s.logs = d; s.count = d.length; s.next = null; s.previous = null;
        } else {
          s.logs = d.results ?? []; s.count = d.count ?? 0;
          s.next = d.next; s.previous = d.previous;
        }
      })
      .addCase(fetchAuditLogs.rejected, (s) => { s.loading = false; })

      /* Résumé par utilisateur */
      .addCase(fetchAuditResume.pending,  (s) => { s.loadingResume = true; })
      .addCase(fetchAuditResume.fulfilled,(s, a) => { s.loadingResume = false; s.resume = a.payload; })
      .addCase(fetchAuditResume.rejected, (s) => { s.loadingResume = false; });
  },
});

export default auditSlice.reducer;
